import isEmpty from "../lib/isEmpty";

// const emailRegex =
//   /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;
// const passwordRegex = /^(?=.\d)(?=.[A-Z])(?=.[a-z])(?=.\W).{6,18}(?!\S)$/;

export const registerValid = (reqBody) => {
  const emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;
  const passwordRegex =
    /(?=^.{8,}$)(?=.{0,}[A-Z])(?=.{0,}[a-z])(?=.{0,}\W)(?=.{0,}\d)/g;
  let errors = {};
  if (isEmpty(reqBody.firstName)) {
    errors.firstName = "First Name is required";
  }

  if (isEmpty(reqBody.lastName)) {
    errors.lastName = "Last Name is required";
  }

  if (isEmpty(reqBody.email)) {
    errors.email = "Email is required";
  } else if (!emailRegex.test(reqBody.email)) {
    errors.email = "Email is invalid";
  }

  // if (isEmpty(reqBody.jobTitle)) {
  //   errors.jobTitle = "Job Title is required";
  // }

  // if (isEmpty(reqBody.companyName)) {
  //   errors.companyName = "Company Name is required";
  // }

  // if (isEmpty(reqBody.country)) {
  //   errors.country = "Country is required";
  // }

  // if (isEmpty(reqBody.typesOfService)) {
  //   errors.typeOfService = "Type Of Service is required";
  // }

  if (isEmpty(reqBody.password)) {
    errors.password = "Password is required";
  }
  if (isEmpty(reqBody.confirmPassword)) {
    errors.confirmPassword = "Confirm Password is required";
  }
  // if (isEmpty(reqBody.manPowerRequirement)) {
  //   errors.manPowerRequirement = "Manpower Requirement is required";
  // }

  // if (isEmpty(reqBody.password)) {
  //   errors.password = "password is required";
  // } else if (!passwordRegex.test(reqBody.password)) {
  //   errors.password = "password is invalid";
  // }

  // if (isEmpty(reqBody.confirmPassword)) {
  //   errors.confirmPassword = "confirm Password is required";
  // } else if (reqBody.password != reqBody.confirmPassword) {
  //   errors.password = "confirm password is not same";
  // }

  if (isEmpty(reqBody.phoneNo)) {
    errors.phoneNo = "Phone No is required";
  } else if (reqBody.phoneNo.toString().length != 10) {
    errors.phoneNo = "Phone No must 10 digits allowed only";
  }

  if (!isEmpty(errors)) {
    return {
      status: false,
      errors,
    };
  }

  return { status: true };
};
